import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { connect } from 'react-redux';
import Info from '../../info';
import { updateShowSetMinDurationsModal } from '../../../../actions/modal';
import { updateMinDurationsValues } from '../../../../actions/report';

export default function RightPanelSetMinDurations(props) {
  const dispatch = useDispatch();
  const typingMinConDurationValue = useSelector((state) => state.reportReducer.typingMinConDurationValue);
  const typingMinMeetingDurationValue = useSelector((state) => state.reportReducer.typingMinMeetingDurationValue);
  const fetchingReports = useSelector((state) => state.reportReducer.fetchingReports);
  const updatingMinDurations = useSelector((state) => state.reportReducer.updatingMinDurations);

  const cancelSetMinDurations = (e) => {
    dispatch(updateShowSetMinDurationsModal(false));
  };

  const updateMinDurations = (e) => {
    if (!window.$(e.target).hasClass('disable')) {
      let durationValues = [typingMinConDurationValue * 60, typingMinMeetingDurationValue * 60];
      let reportsVars = [
        props.startDate == null ? null : props.startDate.format('YYYY-MM-DD'),
        props.endDate == null ? null : props.endDate.format('YYYY-MM-DD'),
      ];

      let cb = (showModal) => {
        dispatch(updateShowSetMinDurationsModal(showModal));
      };
      dispatch(updateMinDurationsValues(durationValues, reportsVars, props.userId, cb));
    }
  };

  let saveClasses =
    'ui labeled icon button icon color-button color-button-hover color-white  max-width left-text mrlnull mrbnull';
  let cancelClassName =
    'ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mrtm';
  return (
    <div>
      <div className="ui actions mrbl max-width ">
        <button
          type="button"
          tabIndex="3"
          onClick={updateMinDurations}
          data-group="setMinDurationsForm"
          className={fetchingReports && updatingMinDurations ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.OK}
          <i className="checkmark icon" />
        </button>
        <button type="button" tabIndex="4" onClick={cancelSetMinDurations} className={cancelClassName}>
          <i className="remove icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
      <Info
        paragraphs={[APP.LANGUAGE.UpdateMinDurations.InfoDuration]}
        moreInfoLink={APP.EXTERNAL_LINKS.UserProfile.MoreInfo}
      />
    </div>
  );
}
